import { render } from "./tw-footer.vue?vue&type=template&id=c3cd14a8"
import script from "./tw-footer.vue?vue&type=script&lang=js"
export * from "./tw-footer.vue?vue&type=script&lang=js"
script.render = render

export default script